import React from "react";

import { withStyles } from "@mui/styles";
import { Card, CardContent } from "@mui/material";

const StyledCard = withStyles({
  root: {
    border: "1px solid #cccccc",
    borderRadius: "3px",
    backgroundColor: "#eeeeee",
    padding: "0.5em",
    marginTop: "0.5em",
  },
})(Card);

const StyledCardContent = withStyles({
  root: {
    fontSize: "smaller",
    padding: "0",
    "& pre": {
      lineHeight: 1.15,
    },
    "&:last-child": {
      padding: "0",
      lineHeight: 1,
    },
  },
})(CardContent);

export default function CodeCard(props) {
  return (
    <StyledCard>
      <StyledCardContent>
        <code>{props.children}</code>
      </StyledCardContent>
    </StyledCard>
  );
}

// code {
// }
